export function pluralize(count, word) {
  return count === 1 ? "1 ".concat(word) : "".concat(count, " ").concat(word, "s");
}